import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { StyleSheet, css } from 'aphrodite/no-important';
import Logo from '../../../Images/logo.png';
export default class Wrapper extends Component{
    render(){
        const { row, col } = styles;
        return (
            <Container>
                <Row noGutters className={css(row)}>
                    <Col className={`shadow-sm rounded ${css(col)}`} xs={{ size: 10, offset: 1 }} md={{ size: 6, offset: 3 }} lg={{ size: 4, offset: 4 }}>
                        <Row className='mb-3'>
                            <Col xs={{ size: 8, offset: 2 }}>
                                <img src={Logo} alt="Niggle" className="img-fluid"/>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs='12'>
                                { this.props.children }
                            </Col>
                        </Row>
                    </Col>
                </Row>    
            </Container>
        );
    }
}

const styles = StyleSheet.create({
    row: {
        paddingTop: '10vh',
    },
    col: {
        backgroundColor: '#fff', 
        padding: '15px !important', 
        paddingBottom: '5vh',
    },
});



// WEBPACK FOOTER //
// ./src/Components/Auth/Layout/Wrapper.js